import {ProductFeed, RemoteProductFeed} from './productFeed.types';
import {DateTime} from 'luxon';

function toClientProductFeed(remoteFeed: RemoteProductFeed): ProductFeed {
  return {
    ...remoteFeed,
    lastUploadDate: DateTime.fromISO(remoteFeed.lastUploadDate),
  };
}

export default toClientProductFeed;
